import { IViewFolder } from "../../interfaces/CustomViewFolder";
import { FolderViewChild } from "../../interfaces/ViewFolderResponse";
import { GetFolderTypeFromScopeType, GetViewCategoryFromScopeType } from "./MappingUtilities";

export const mapViewFolderChildToViewFolder = (folderViewChild: FolderViewChild): IViewFolder => {
  const mappedFolderView: IViewFolder = {
    id: folderViewChild.Id,
    name: folderViewChild.Name,
    parentId: folderViewChild.ParentId ?? null,
    createdOn: '',
    isFavorite: false,
    isDefault: false,
    category: GetViewCategoryFromScopeType(folderViewChild.ScopeType, folderViewChild.DocType),
    folderType: null,
    adoFolderId: null,
    temporaryViewID: null,
    children: null, //Set to null to indicate children folders aren't loaded
    level: 0,
  };

  if (folderViewChild.DocType === 'Folder') {
    mappedFolderView.folderType = GetFolderTypeFromScopeType(folderViewChild.ScopeType);
  }

  return mappedFolderView;
}